import ModalDepositCreate from './ModalDepositCreate';
import ModalDepositDelete from './ModalDepositDelete';
import ModalDepositFilter from './ModalDepositFilter';
import ModalDepositUpdate from './ModalDepositUpdate';
import ModalDepositUpdateMany from './ModalDepositUpdateMany';

export default Object.assign(
  {},
  {
    Create: ModalDepositCreate,
    Update: ModalDepositUpdate,
    Filter: ModalDepositFilter,
    Delete: ModalDepositDelete,
    UpdateMany: ModalDepositUpdateMany,
  },
);
